module.exports = ".modal-body{font-size:1.5em;padding:30px}\n"